import { Spin } from 'antd';
import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import { useParams, useLocation } from "react-router-dom";
import allActions from '../../actions';
import { useIdoTokenClaimContract } from '../../hooks/useContract';
import { getNetworkObject } from '../../utils/campaignUltils';
import { formatNumber, formatNumberCurrency, truncateNumber } from '../../utils/formatNumberCurrency';
import AirdropCountdown from '../common/AirdropCountdown';
import LogoKDG from '../common/asset/images/icon-kdg.svg';
import { _claimTokens, _isClaimedSC } from './utils';
import { Store } from 'react-notifications-component';
import addNotify from '../common/Notify/addNotify';
import { CHAINID_CONVERT } from '../../constants';
import { useAccount } from 'wagmi';
import { useWeb3ModalState } from '@web3modal/wagmi/react';

const SpinLoading = () => <Spin size="small" style={{position: 'absolute', marginLeft: "5px"}}/>;

const DetailAirdrop = () => {

    const dispatch = useDispatch();
    const { handle } = useParams();

    const { address } = useAccount();
    const { selectedNetworkId } = useWeb3ModalState()
    const chainId = selectedNetworkId;
    let account = address;

    const [isClaim, setIsClaim] = useState(false);
    const airdropData = useSelector(state => state.airdrop.airdropData);
    const airdropWhitelist = useSelector(state => state.airdrop.airdropWhitelist);
    const airdropContract = useIdoTokenClaimContract(airdropWhitelist && airdropWhitelist.contractAddress);
    const nowDate = new Date();
    const [isLoadingClaim, setIsLoadingClaim] = useState(false);
    var startClaimDate = new Date(airdropData?.startClaim);
    var expiredDate = startClaimDate;
    expiredDate.setDate(startClaimDate.getDate() + 7);
    let tokenDecimals = airdropData?.tokenInform?.decimals;

    useEffect(() => {
        dispatch(allActions.airdropAction.getAirdropDetail(handle));
    }, [dispatch]);

    useEffect(() => {
        if(airdropData?.id && account) {
            dispatch(allActions.airdropAction.getWhitelistAirdropByAddressDetail(airdropData?.id, account.toLowerCase()));
        }
    }, [dispatch, airdropData?.id, account]);
     
    useEffect(() => {
        try {
            if (airdropContract !== null) {
                _isClaimedSC(airdropContract, account).then((res) => {
                    setIsClaim(res);
                });
            }
        } catch (error) {
            setIsClaim(false);
        }
    }, [account, airdropContract]);

    const networkChain = getNetworkObject(airdropData?.network);  

    const handleClaim = async () => {
        setIsLoadingClaim(true); 
        // if(chainId && CHAINID_CONVERT[chainId].toUpperCase() !== airdropData?.network){
        //     Store.addNotification(addNotify('Wrong Network', 'danger'));
        //     setIsLoadingClaim(false);
        //     return false;
        // }

        if (!airdropWhitelist) {
            Store.addNotification(addNotify('Invalid data', 'danger'));
            setIsLoadingClaim(false);
            return false;
        }

        if (!airdropWhitelist.sign) {
            Store.addNotification(addNotify('Invalid signature', 'danger'));
            setIsLoadingClaim(false);
            return false;
        }

        if (!airdropWhitelist.totalAmount) {
            Store.addNotification(addNotify('Invalid token amount', 'danger'));
            setIsLoadingClaim(false);
            return false;
        }
        
        const _airdropWhitelist = {
            tokenAmount: airdropWhitelist?.totalAmount,
            roundId: airdropData?.id,
            signatureIDO : airdropWhitelist?.sign
        }

        if (airdropContract !== null && airdropWhitelist?.totalAmount > 0) {
            await _claimTokens(airdropContract, _airdropWhitelist, tokenDecimals, false)
            .then((res) => { 
                let resWait = res.wait();
                resWait.then((resTransaction) => {
                    if (resTransaction && resTransaction.status && resTransaction.blockNumber) {
                        // actions.updateAmountClaimTokens(itemClaim.claimRoundId, account, itemClaim.tokenAmount, itemClaim.id);
                        setIsClaim(true);
                        setIsLoadingClaim(false);
                    }
                });
            })
            .catch((error) => {
                setIsLoadingClaim(false);
                Store.addNotification(addNotify('Error claim!', 'danger'));
            });
        }
    }

    const handleButtonClaim = () => { 
        let item;
        if(airdropWhitelist && airdropWhitelist?.totalAmount > 0){
            if(isClaim) {
                item = (<>
                            <p>Your Reward: <span>{formatNumber(airdropWhitelist?.totalAmount, 6)} {airdropData?.tokenInform?.symbol}</span></p>
                            <button className="c-btn" disabled>Claimed</button>
                        </>);
            }
            else {
                if(nowDate > expiredDate) {
                    item = (<>
                                <p>Your Reward: <span>{formatNumber(airdropWhitelist?.totalAmount, 6)} {airdropData?.tokenInform?.symbol}</span></p>
                                <button className="c-btn" disabled>Expired</button>
                            </>);
                }
                else {
                    item = (<>
                                <p>Your Reward: <span>{formatNumber(airdropWhitelist?.totalAmount, 6)} {airdropData?.tokenInform?.symbol}</span></p>
                                <button className="c-btn" onClick={() => handleClaim()}>Claim {isLoadingClaim && SpinLoading()}</button>
                            </>);
                }
            }
        }
        else {
            item = <button className="c-btn" disabled>You're not in whitelist</button>;
        }
        
        return item;
    }

    return(
        <div className="p-airdropDetail">
            <h2 style={{textTransform: 'uppercase'}}>{airdropData?.title}</h2>
            <ul>
                <li><img src={airdropData?.tokenInform?.logoURL} alt='' />{airdropData?.tokenInform?.symbol}</li>
                <li><img src={networkChain?.logo} alt='' />{networkChain?.name}</li>
                <li><AirdropCountdown item={airdropData} positions="AIRDROP_DETAIL" /></li>
            </ul>
            {handleButtonClaim()}
        </div>
    );
}
export default DetailAirdrop; 